import APIManager from 'api/APIManager';
import APIConstant from 'api/APIConstant';
import { parameterToPath } from 'utils';

export type Stock = {
  stock_id?: number; // 재고관리 idx
  stock_code?: string; // 재고 코드
  stock_name?: string; // 품목 명
  created_at?: number; // 생성일
  updated_at?: number; // 수정일
};

const $http = new APIManager();

const Api = {
  /**
   * [GETS] Stock
   * --
   */
  getStocks: async (params?: { [key: string]: string | number }) => {
    try {
      const res = await $http.get(APIConstant.GETS_STOCK, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [GET] Stock
   * --
   */
  getStock: async (
    idx: number,
    params?: { [key: string]: string | number }
  ) => {
    try {
      const url = parameterToPath(APIConstant.GET_STOCK, { stock_id: idx });
      const res = await $http.get(url, params);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [POST] Stock
   * --
   */
  createStock: async (body: Stock) => {
    try {
      const res = await $http.post(APIConstant.CREATE_STOCK, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [PUT] Stock
   * --
   */
  updateStock: async (body: Stock) => {
    try {
      const { stock_id } = body;
      const url = parameterToPath(APIConstant.UPDATE_STOCK, {
        stock_id: stock_id,
      });

      const res = await $http.put(url, body);

      return res;
    } catch (e) {
      throw e;
    }
  },

  /**
   * [DELETE] Stock
   * --
   */
  deleteStock: async (idx: number) => {
    try {
      const url = parameterToPath(APIConstant.UPDATE_STOCK, {
        stock_id: idx,
      });

      const res = await $http.delete(url);

      return res;
    } catch (e) {
      throw e;
    }
  },
};

export default Api;
